{
  "title": "تسليم أمانة",
  "description": "امسح رمز الأمانة بكاميرا التابلت أو أدخل الرقم المرجعي المطبوع على الوصل.",
  "tabletRequired": "اختر جهاز التابلت",
  "find": {
    "title": "البحث عن الأمانة",
    "hint": "أدخل الرقم المرجعي عند تعذر قراءة الرمز.",
    "scanning": "الكاميرا مفتوحة على التابلت. اطلب من العميل عرض الرمز."
  },
  "refusal": {
    "unknown": "الرقم المرجعي غير معروف",
    "notInCustody": "هذه الأمانة ليست في حوزتنا ({{state}})",
    "closedBy": "ليست في حوزتنا. الحالة: {{state}}، بواسطة {{name}} في {{at}}",
    "otherBranch": "هذه الأمانة محفوظة في {{branch}}",
    "forbidden": "ليس لديك صلاحية تسليم الأمانات في هذا الفرع"
  },
  "found": {
    "title": "بيانات الأمانة",
    "depositedAt": "تاريخ الإيداع",
    "noIntended": "لم تسجل بيانات المستلم. تحقق من هوية المستلم يدويا."
  },
  "referralPending": "هذه الأمانة بانتظار مراجعة المشرف ولا يمكن تسليمها الآن.",
  "start": {
    "deliver": "تسليم"
  },
  "waiting": {
    "recipient": "النموذج معروض على التابلت. بانتظار المستلم.",
    "depositor": "النموذج معروض على التابلت. بانتظار المودع.",
    "offline": "التابلت غير متصل. تأكد من تشغيله ثم أعد الإرسال.",
    "reconnecting": "انقطع الاتصال المباشر. جاري إعادة الاتصال..."
  },
  "compare": {
    "snapshot": "بيانات المودع عند الإيداع"
  },
  "decide": {
    "deliveryHint": "قارن بيانات المستلم بالمستلم المقصود ثم قرر.",
    "returnHint": "قارن بيانات المودع ببياناته عند الإيداع ثم قرر.",
    "deliverStatement": "تسليم النقد إلى {{name}}",
    "returnStatement": "إعادة النقد إلى المودع {{name}}",
    "referStatement": "تبقى الأمانة في حوزتنا بانتظار مراجعة المشرف. اكتب سبب الإحالة."
  },
  "closed": {
    "DELIVERED": "تم تسليم الأمانة بنجاح",
    "RETURNED": "تم استرداد الأمانة بنجاح",
    "REFERRED": "تمت إحالة الأمانة للمشرف",
    "number": "رقم الأمانة {{number}}"
  },
  "nextDeposit": "تسليم أمانة أخرى"
}
